import axios from 'axios';
import config from './config.js';
const URL = config.urls.api;

// Makes is like a singleton but super easy :).
const AuthConfig = {
  headers: {
    Authorization: ""
  }
};

class Api {
  static getWatchlist = async () => {
    const url = `${URL}/watchlist`;
    const res = await axios.get(url);
    return res.data;
  }

  static trackClick = async (id) => {
    const url = `${URL}/watchlist/click/${id}`;
    const res = await axios.post(url);
    return res.data;
  }

}

export default Api;